import { i18n } from "@v2/shared/config";

export const localeField = (data, field, symbol) => {
  const locales = {
    en: "_eng",
    ru: "_rus"
  };
  const locale = locales[i18n.locale];

  return data && field ? data[field + locale] : symbol;
};
